import { useMemo } from 'react';

import {
  checkActiveRange,
  getSafeNormalRange,
  getStartEndNormalRange,
} from '../../../utils';

export function useLabTestResultDetailsData({ entity }) {
  const iconType = 'icon-arrow-down';
  const {
    componentAbnormalStatus,
    componentName,
    componentResultNormalRange,
    componentResultUnits,
    componentResultValue,
    isPrivate,
  } = entity;
  const safeUnits = componentResultUnits || '';
  const shouldShowScale = /^\d+(\.\d+)?-\d+(\.\d+)?$/.test(componentResultNormalRange);
  const safeViewValue = getSafeNormalRange(componentResultValue, safeUnits);
  const safeValue = componentResultValue
    ? parseFloat(componentResultValue.replace(/[^\d.]/g, ''))
    : '';
  const safeNormalRange = getSafeNormalRange(
    componentResultNormalRange,
    safeUnits,
  );
  const {
    startPointNormal,
    endPointNormal,
    endPointHigh,
    startPointLow,
  } = getStartEndNormalRange(componentResultNormalRange);

  const { normalActive, highActive, lowActive } = checkActiveRange(
    startPointNormal,
    endPointNormal,
    endPointHigh,
    startPointLow,
    componentResultValue,
  );

  return useMemo(() => {
    return {
      safeValue,
      componentAbnormalStatus,
      componentName,
      componentResultValue,
      highActive,
      iconType,
      isPrivate,
      normalActive,
      lowActive,
      safeNormalRange,
      safeViewValue,
      shouldShowScale,
      rangePointsArray: [
        startPointLow,
        startPointNormal,
        endPointNormal,
        endPointHigh,
      ],
    };
  }, [
    entity,
    safeValue,
    componentAbnormalStatus,
    componentName,
    componentResultValue,
    highActive,
    iconType,
    isPrivate,
    normalActive,
    lowActive,
    safeNormalRange,
    safeViewValue,
    shouldShowScale,
    startPointLow,
    startPointNormal,
    endPointNormal,
    endPointHigh,
  ]);
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/useLabTestResultDetailsData.jsx